import * as React from 'react';
import {FACompsBySeasonDate, FAComps} from '@nls-2022/nls-bll';
import {computeHeadingLevel} from '@testing-library/react';
import {FACompBlogContentType, FACompDetailsType} from '@nls-2022/nls-bll';
import {Select} from './BlogFormInputs';
export type BlogPostSelectRoundPropsType = {
  handleRoundChange: any;
  selectedSeason: string;
  selectedComp: string | undefined | null;
  selectedRound: string | undefined | null;
};

//const Select = ({register, name, options, defaultValue, ...rest}: any) => {
//  return (
//    <select defaultValue={defaultValue} {...register(name)} {...rest}>
//      {options.map((option: string, index: string) => (
//        <option value={option} key={index}>
//          {option}
//        </option>
//      ))}
//    </select>
//  );
//};

const BlogPostSelectRoundV2 = ({
  register,
  selectedSeason,
  selectedComp,
  selectedRound,
}: any) => {
  let compDataforSeason = FACompsBySeasonDate.find((u: {season: any}) => {
    return u.season === selectedSeason;
  });
  if (selectedComp === undefined || selectedComp === null) {
    return <></>;
  }
  let faComp = FAComps.find((u: {name: any}) => u.name === selectedComp);
  let roundDetails: Array<string> | undefined =
    compDataforSeason?.compDetailsList
      .filter((u: {comp: any}) => u.comp === faComp?.comp)
      .map((r: {roundName: any}) => r.roundName);
  if (roundDetails === undefined || roundDetails.length === 0) {
    return <></>;
  }

  return (
    <div className="mb-4 mr-4">
      <label className="block text-gray-700 text-sm font-bold mb-2">
        Round
      </label>
      <Select
        name="Round"
        register={register}
        options={roundDetails}
        defaultValue={selectedRound}
      />
    </div>
  );
};
export default BlogPostSelectRoundV2;
